import Actions         from "../../../../model/constant/actions"
import ReducerUtils    from "../../../../utils/ReducerUtils"

const Retrieving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_ADCOPY_ACTIVE_STRATEGIES] : (_state,action) => action.status
})

export default Retrieving
